import {
  fallback,
  zodValidator,
} from '@tanstack/zod-adapter';
import {
  z,
} from 'zod';

export const sorting = z.object({
  id: z.string(),
  desc: z.boolean(),
}).array().optional();

export const filters = z.object({
  id: z.string(),
  value: z.unknown(),
}).array().optional();

export const fetchSize = z.number()
  .finite()
  .int()
  .min(1)
  .max(100)
  .optional();

export const tableSearchParamsSchema = z.object({
  sorting: fallback(sorting, []),
  filters: fallback(filters, []),
  fetchSize: fallback(fetchSize, 50),
});

export type TableSearchParams = z.infer<typeof tableSearchParamsSchema>;
export const tableSearchValidator = zodValidator(tableSearchParamsSchema);

export default tableSearchValidator;
